import { type MaskitoOptions } from '@maskito/core';
import { maskWithPlaceholder } from 'utils/maskito';

export const DATE_OF_BIRTH_PLACEHOLDER = 'MM/DD/YYYY';

export const DATE_OF_BIRTH_MASK_OPTIONS: MaskitoOptions = maskWithPlaceholder(
  [/\d/, /\d/, '/', /\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/],
  DATE_OF_BIRTH_PLACEHOLDER,
);
